module.exports = __webpack_public_path__ + "img/24.cb570aaa.png";